var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTrashcan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_trashcan_svg__Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".icon_trashcan_svg__st1{display:inline;fill:#004aad}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon_trashcan_svg__st2",
    d: "M28.6 37.5h2.5c.8 0 1.6-.7 1.7-1.6L35 15.5c.1-.9-.5-1.6-1.3-1.6l-22.3.1c-.8 0-1.4.7-1.3 1.6l2.3 20.3c.1.9.9 1.6 1.7 1.6h2.1m1.4 0h9.5m0-1.3h-9.5m-1.5.1h-1.4c-.9 0-1.2-.3-1.3-1.2l-2.2-18.7c-.1-.9-.2-1.2.6-1.2h.3l20.5-.1c.9 0 1.1.3 1 1.2l-2 18.7c-.1.9-.5 1.2-1.3 1.2h-1.7M34.8 12.7c0-.1-.1-.2-.1-.2s-4.8-.2-8.8-.3c0-.1.1-.3.1-.4.1-1.9-1.4-3.6-3.4-3.6C20.7 8 19 9.5 19 11.5v.4c-4.6-.2-8.5-.3-8.5-.3-.1 0-.2 0-.2.2v.6c0 .1.1.2.2.2s10.1.4 17.2.6c3.5.2 7.1.3 7.2.3.1 0 .1-.1.1-.2-.2-.1-.2-.5-.2-.6zm-9.8-.6l-5-.2v-.3c.1-1.4 1.2-2.5 2.6-2.4 1.4.1 2.5 1.2 2.4 2.6v.3z"
  })));
}

export default SvgIconTrashcan;